/**
 * Bootstrap's modal hides on any click whose target is the backdrop, and a press that starts
 * in the content and ends on the backdrop (selecting text, say) clicks the backdrop. Only a
 * press that also started on the backdrop should reach that handler.
 */
export function ignoreBackdropDrags(modal) {
	let pressStartedOn = null;
	modal.addEventListener('mousedown', (event) => {
		pressStartedOn = event.target;
	}, true);
	modal.addEventListener('click', (event) => {
		if(event.target === modal && pressStartedOn && pressStartedOn !== modal) {
			event.stopImmediatePropagation();
		}
		pressStartedOn = null;
	}, true);
}
